export const onRegistrationStarted = () => {
    console.log('registration started');
};
